export const SURVEY_BILLING_MONTHLY = "monthly";
export const SURVEY_BILLING_ANNUAL = "annual";

export const SURVEY_TIER_PRICES = {
  plus: {
    monthly: { amount: 89, headline: "$89", period: "/month", label: "$89/month" },
    annual: { annualTotal: 890, headline: "$890", period: "/year", label: "$890/year" },
  },
  pro: {
    monthly: { amount: 179, headline: "$179", period: "/month", label: "$179/month" },
    annual: { annualTotal: 1790, headline: "$1,790", period: "/year", label: "$1,790/year" },
  },
  pro_plus: {
    monthly: { amount: 379, headline: "$379", period: "/month", label: "$379/month" },
    annual: { annualTotal: 3790, headline: "$3,790", period: "/year", label: "$3,790/year" },
  },
};

export function normalizeSurveyBillingCycle(cycle) {
  return cycle === SURVEY_BILLING_ANNUAL ? SURVEY_BILLING_ANNUAL : SURVEY_BILLING_MONTHLY;
}

export function surveyPriceDisplay(tier, billingCycle) {
  const prices = SURVEY_TIER_PRICES[tier];
  if (!prices) return null;
  const cycle = normalizeSurveyBillingCycle(billingCycle);
  const row = prices[cycle];
  if (!row) return null;
  return {
    headline: row.headline,
    period: row.period,
    saveNote: cycle === SURVEY_BILLING_ANNUAL ? "SAVE 2 MONTHS" : null,
    label: row.label,
  };
}

export function surveyThenAmountLabel(tier, billingCycle) {
  return surveyPriceDisplay(tier, billingCycle)?.label || "";
}
